export const isTomanCurrency = (currency) => {
  const values = [
    currency?.currency_symbol,
    currency?.currency_code,
    currency?.currency_name,
    currency?.name,
  ].map((value) => String(value || '').trim().toLowerCase());

  return values.some((value) => value === 'تومان' || value === 'toman' || value === 'irt');
};

export const getDefaultCurrencyId = (currencies = []) => {
  if (!Array.isArray(currencies) || currencies.length === 0) return undefined;
  return (currencies.find(isTomanCurrency) || currencies[0])?.id;
};
